<div class="assets-library-main" id="assets-library">
  @if (assetsStatus !== 'noAssets') {
    <div class="assets-library-container">
      <div class="assets-library-top-panel">
        <button
          class="upload-new-image-btn"
          (click)="uploadNewAsset($event)"
          [disabled]="!canEditAssets()"
          [ngStyle]="{ visibility: canEditAssets() ? 'visible' : 'hidden' }"
          >
          <span class="cross"></span> Upload
        </button>
        <label>
          <input
            class="searchBtn"
            placeholder="Search"
            type="text"
            value=""
            [(ngModel)]="searchValue"
            />
          </label>
        </div>
        <div class="assets-table-container">
          <div class="assets-table-block">
            <assets-table
              [searchValue]="searchValue"
              [canEdit]="canEdit"
              [canSelect]="canSelect"
              [assetsStatus]="assetsStatus"
              (checkAssets)="checkAssets($event)"
            ></assets-table>
          </div>
        </div>
      </div>
    } @else {
      <div class="assets-library-empty">
        <p>Upload files to add them to your asset library.</p>
        <button
          class="upload-new-image-btn"
          (click)="uploadNewAsset($event)"
          [disabled]="!canEditAssets()"
          >
          + Upload
        </button>
      </div>
    }
  </div>

  <upload-asset
    [startUpload]="showUploadModal"
    (cancelUploadEvHandler)="cancelUpload()"
    (finishUploadEvHandler)="finishUpload()"
  ></upload-asset>

